import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  OnDestroy,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SearchResultsComponent } from '@adw/projects/aca-content/src/lib/components/search/search-results/search-results.component';

import {
  SavedSearchesService,
  SearchQueryBuilderService,
  TagService,
} from '@alfresco/adf-content-services';
import { ShowHeaderMode, TranslationService } from '@alfresco/adf-core';
import { takeUntil } from 'rxjs/operators';

import { WkDocumentListComponent } from '../../forked/components/wk-document-list/wk-document-list.component';
import { WkDocumentListService } from '../../services/wk-document-list.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'wk-search-results',
  templateUrl: './wk-search-results.component.html',
  styleUrls: ['./wk-search-results.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'aca-search-results-row' },
})
export class WkSearchResultsComponent
  extends SearchResultsComponent
  implements OnDestroy
{
  @ViewChild(WkDocumentListComponent, { static: false })
  public wkDocList: WkDocumentListComponent | undefined;
  public readonly showHeader = ShowHeaderMode.Never;
  public readonly wkDocListService: WkDocumentListService | undefined;
  private readonly onDestroy$ = new Subject<boolean>();

  constructor(
    queryBuilder: SearchQueryBuilderService,
    route: ActivatedRoute,
    translationService: TranslationService,
    private readonly wkQueryBuilder: SearchQueryBuilderService
  ) {
    super(
      inject(TagService),
      queryBuilder,
      inject(ChangeDetectorRef),
      route,
      translationService,
      inject(SavedSearchesService)
    );

    this.wkDocListService = inject(WkDocumentListService);

    if (this.wkDocListService?.pagination) {
      queryBuilder.paging = {
        skipCount: this.wkDocListService.pagination.skipCount,
        maxItems: this.wkDocListService.pagination.maxItems,
      };
    }
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.wkDocListService
      ?.isReloaded()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(() => {
        if (this.searchedWord || this.wkQueryBuilder.userQuery) {
          this.wkQueryBuilder.update();
        }
      });
  }

  override ngOnDestroy(): void {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }
}
